/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from "react";

import { Carousel } from "antd";
import styles from "./styles/TipsSection.scss";
import { TIPS } from "../constants";
import Paging from "../AdDetailsPageMobile/SimilarAdsSection/SimilarAdsCarousel/Paging";
import { generateUUID } from "../../../services/utils";
import { getIconUrl } from "../../../services/asset";

export interface carouselDefaultResponsiveSettingsI {
  breakpoint: number;
  settings: {
    slidesToShow: number;
    slidesToScroll: number;
  };
}

export interface TipsSectionProps {
  isMobile: boolean;
  className?: string;
  responsiveSettings?: carouselDefaultResponsiveSettingsI[];
}

const carouselDefaultResponsiveSettings: carouselDefaultResponsiveSettingsI[] = [
  {
    breakpoint: 1900,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  },
  {
    breakpoint: 1600,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4
    }
  },
  {
    breakpoint: 1400,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  },
  {
    breakpoint: 1000,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  },
  {
    breakpoint: 700,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }
];

function TipsSection({
  isMobile,
  className,
  responsiveSettings
}: TipsSectionProps) {
  const [tipIds] = useState(TIPS.map(() => generateUUID()));

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleResize = () => {
    const elements = TIPS.map((item, index) =>
      document.getElementById(tipIds[index])
    );
    const maxHeight = Math.max(...elements.map(item => item.offsetHeight));
    const maxHeightPx = `${maxHeight}px`;

    elements.forEach(item => {
      item.style.height = maxHeightPx;
    });
  };

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.titleContainer}>
        <img
          alt={"Mjere sigurnosti"}
          className={styles.tipTitleIcon}
          src={getIconUrl("tip-title.svg")}
        />
        <span className={styles.titleTip}>{"Mjere sigurnosti"}</span>
      </div>

      <Carousel
        className={styles.tips}
        slidesToShow={isMobile ? 1 : 4}
        slidesToScroll={isMobile ? 1 : 4}
        // @ts-ignore
        customPaging={Paging}
        infinite={false}
        swipe
        draggable
        centerMode={isMobile}
        responsive={responsiveSettings}
      >
        {TIPS.map((item, index) => (
          <div className={styles.tip} key={tipIds[index]} id={tipIds[index]}>
            <div>
              <span className={styles.tipNumber}>{index + 1}</span>
              <span className={styles.tipTitle}>Savjet</span>
            </div>
            <div className={styles.tipContent}>{item}</div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}

TipsSection.defaultProps = {
  isMobile: false,
  className: "",
  responsiveSettings: carouselDefaultResponsiveSettings
};

export default TipsSection;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/TipsSection.tsx